var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add New Vendor - API / OCR - Yes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-27254 -507C-27254 -508.105 -27253.1 -509 -27252 -509H6979C6980.11 -509 6981 -508.105 6981 -507V698C6981 699.105 6980.11 700 6979 700H-27252C-27253.1 700 -27254 699.105 -27254 698V-507Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Add New Vendor",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 710,
    transform: "translate(-274 -260)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 5105"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -107.5,
    y: -107.5,
    width: 1162,
    height: 471,
    rx: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 5104"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -88,
    y: -12,
    width: 109,
    height: 35,
    rx: 5,
    fill: "#EBEEF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.8125 8.25V2.64687L3.025 4.43437L2.0625 3.4375L5.5 0L8.9375 3.4375L7.975 4.43437L6.1875 2.64687V8.25H4.8125ZM1.375 11C0.996876 11 0.673064 10.8652 0.403564 10.5957C0.134064 10.3262 -0.000457166 10.0027 1.16723e-06 9.625V7.5625H1.375V9.625H9.625V7.5625H11V9.625C11 10.0031 10.8653 10.3269 10.5958 10.5964C10.3263 10.8659 10.0027 11.0005 9.625 11H1.375Z",
    fill: "#5E6366"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -107.5,
    y: -107.5,
    width: 1162,
    height: 471,
    rx: 9.5,
    stroke: "#C8C8C8"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-27252 -508H6979V-510H-27252V-508ZM6980 -507V698H6982V-507H6980ZM6979 699H-27252V701H6979V699ZM-27253 698V-507H-27255V698H-27253ZM-27252 699C-27252.6 699 -27253 698.552 -27253 698H-27255C-27255 699.657 -27253.7 701 -27252 701V699ZM6980 698C6980 698.552 6979.55 699 6979 699V701C6980.66 701 6982 699.657 6982 698H6980ZM6979 -508C6979.55 -508 6980 -507.552 6980 -507H6982C6982 -508.657 6980.66 -510 6979 -510V-508ZM-27252 -510C-27253.7 -510 -27255 -508.657 -27255 -507H-27253C-27253 -507.552 -27252.6 -508 -27252 -508V-510Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 710,
    fill: "white",
    transform: "translate(-274 -260)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadUp);
export default __webpack_public_path__ + "static/media/DownloadUp.a02e97a3d7a79ebdf86b4ee13161c853.svg";
export { ForwardRef as ReactComponent };